import { object, string, boolean } from '~utils/validation';

export default object({
  name: string().name().required(),
  email: string().email().required(),
  cellphone: string().cellphone().required(),
  cpf: string().cpf().required(),
  birthdayDate: string().birthdayDate().required(),
  motherName: string().name().required(),
  zipCode: string().zipCode().required(),
  state: string().required(),
  city: string().required(),
  neighborhood: string().required(),
  street: string().max(40).required(),
  number: string().required(),
  complement: string().optional(),
  declaredIncome: string().required(),
  politicallyExposedPerson: boolean().optional(),
});
